export const surveyRoutes = [
    // {
    //     path: '/enquetes',
    //     label: 'Tableau de bord',
    //     icon: 'faTableColumns',
    //     roles: []
    // },
    {
        path: '/enquetes/participations',
        label: 'Participations',
        icon: 'faUsers',
        roles: ['survey-participation.read']
    },
    {
        path: '/enquetes/surveys',
        label: 'Enquêtes',
        icon: 'faPoll',
        roles: ['survey.read']
    },
    {
        label: 'Reporting',
        icon: 'faChartBar',
        dropdown: true,
        roles: ['reporting'],
        path: '/enquetes/reporting/synthese',
        children: [
            {
                path: '/enquetes/reporting/synthese',
                label: 'Synthèse',
                roles: ['reporting'],
                reportId: 'synthese'
            }
        ]
    }
];

export const diagnosticsRoutes = [
    {
        path: '/diagnostics',
        label: 'Tableau de bord',
        icon: 'faTableColumns',
        roles: []
    },
    {
        path: '/diagnostics/patrimoine',
        label: 'Patrimoine',
        icon: 'faTableColumns',
        roles: ['real-estate.read']
    },
    {
        path: '/diagnostics/bons-de-commande',
        label: 'Bons de commande',
        icon: 'faTableColumns',
        roles: ['purchase-order.read']
    },
    {
        label: 'Documents',
        dropdown: true,
        icon: 'faTableColumns',
        roles: [],
        children: [
            {
                path: '/diagnostics/documents-entrants',
                label: 'Documents entrants',
                icon: 'faTableColumns',
                roles: ['inbound-document.read']
            },
            {path: '/diagnostics/lots-d-import', label: "Lots d'import", icon: 'faTableColumns', roles: []},
            {path: '/diagnostics/import-de-documents', label: 'Import de documents', icon: 'faTableColumns', roles: []},
        ],
    },
    {
        path: '/diagnostics/reporting',
        label: 'Reporting',
        icon: 'faTableColumns',
        roles: ['reporting']
    },
    {
        path: '/diagnostics/news',
        label: 'News',
        icon: 'faTableColumns',
        roles: []
    }
];